export const ERRORS = Object.freeze({
  ORDER_STATUS_FETCH_ERROR: 'order-fetch-error',
});

export const TAGS = Object.freeze({
  ACCOMMODATION: 'accommodation',
  ACCOMMODATION_TICKETS: 'accommodation tickets',
  ACCOMMODATION_FREE_TICKETS: 'accommodation tickets (free sell permitted)',
});

export const PAYMENT_STATUS = Object.freeze({
  SUCCESS: 'payment-success',
  FAILED: 'payment-failed',
  PENDING: 'Pending',
  LOADING: 'Loading',
  ERROR: 'Error',
});

/** Order API stores agreement fields as `"1"` / `"0"` (matches Drupal order shape). */
export const ORDER_AGREEMENT_OPT_IN = '1';

export const ORDER_STATUS = Object.freeze({
  QUOTE: 'quote',
  PAYMENT_FAILED: 'payment_failed',
  ACTION_REQUIRED: 'action_required',
  CANCELED: 'canceled',
  CUSTOMER_CONTACTED_NO_SALE: 'customer_contacted_no_sale',
  IN_CHECKOUT: 'in_checkout',
  AWAITING_TICKETS: 'awaiting_tickets',
  BROCHURE_ORDER: 'brochure_order',
});

export const FLOW_RETURN_STATUS = Object.freeze({
  SUCCESS: '1',
  FAILED: '2',
  FLAGGED: '3',
});

export const FEATURE_COOKIE = Object.freeze({
  FLOW_PAYMENT: 'CT-188-sdk-flow',
  KLARNA_PAYMENT: 'klarna_enabled',
});

/**
 * Share of customer-accounts sessions auto-enrolled into Flow (0–1).
 * Only applies before FLOW_PAYMENT_MANDATORY_FROM. Ignored once mandatory Flow is active.
 */
export const FLOW_PAYMENT_ROLLOUT_RATE = 0.5;

/**
 * Hard cut-over to Flow for everyone (UTC), regardless of rollout cookie.
 * ISO date YYYY-MM-DD (UTC midnight), or null to disable forced Flow.
 * After this date, CT-188-sdk-flow=0 no longer keeps legacy Frames.
 */
export const FLOW_PAYMENT_MANDATORY_FROM = '2026-06-01';

export const PAYMENT_METHOD = Object.freeze({
  CARD: 'Card',
  APPLE_PAY: 'Apple Pay',
  GOOGLE_PAY: 'Google Pay',
  PAYPAL: 'Paypal',
  IDEAL: 'Ideal',
  GIFT_CARD: 'Gift Card',
});

/** Checkout.com Flow SDK — values passed from customer-accounts into flow-sdk / DOM. */
export const FLOW_CHECKOUT = Object.freeze({
  CONTEXT: 'customer-accounts',
  MOUNT_ELEMENT_ID: 'flow-container',
  DEFAULT_PHONE_PREFIX: '44',
  /** `Payments()` analytics discriminator for Flow (matches legacy method strings). */
  ANALYTICS_PAYMENT_TYPE: 'flow',
});

/** Maps app environment to FlowSDK `setEnv` values. */
export const FLOW_SDK_ENV = Object.freeze({
  LIVE: 'live',
  SANDBOX: 'sandbox',
});

export const FLOW_DISABLED_PAYMENT_METHODS = Object.freeze([
  'klarna',
  'paypal',
]);

/** Brand language key (`utils.getLang`) → Checkout Flow `locale` string. */
export const FLOW_LOCALE_BY_BRAND_LANG = Object.freeze({
  en: 'en-GB',
  'en-ie': 'en-IE',
  'en-us': 'en-US',
  'en-nl': 'en-NL',
  'en-au': 'en-AU',
  'de-de': 'de-DE',
});

export const FLOW_DEFAULT_LOCALE = 'en-GB';

/** Cookie max age in seconds (1 year). */
export const FLOW_COOKIE_MAX_AGE_SECONDS = 31536000;
